module.exports = __webpack_public_path__ + "img/keenUser@2x.dccfc7e6.png";